import * as React from 'react';
import {
  Breadcrumb,
  Button,
  Heading,
} from 'vet-bones/design-system/components';

import { useAppDispatch } from 'src/ui/app/hooks';
import {
  LAUNCHPAD_ENDPOINTS_ADD_EXISTING,
  LAUNCHPAD_ENDPOINTS_ADD_SSO,
  LAUNCHPAD_ENDPOINTS_HEADING,
} from 'src/ui/constants/testIds';
import { LaunchpadEndpointTable } from 'src/ui/containers/endpoints/LaunchpadEndpointTable';
import { DialogType, openedDialog } from 'src/ui/features/ui';
import * as copy from 'src/ui/templates/copy';
import { isSsoConnectionRequired } from 'src/ui/utils/features';

export const LaunchpadEndpoints: React.VFC = () => {
  const dispatch = useAppDispatch();

  const handleAdd = () => {
    dispatch(openedDialog({ type: DialogType.ADD_ENDPOINT }));
  };

  const handleAddSso = () => {
    dispatch(openedDialog({ type: DialogType.ADD_SSO_ENDPOINT }));
  };

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={LAUNCHPAD_ENDPOINTS_HEADING}
            weight="semibold"
          >
            {copy.components.endpoints.dashboard.title}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'endpoints',
                text: copy.components.endpoints.dashboard.breadcrumb.endpoints,
              },
            ]}
          />
        </div>
        <div className="organization-dashboard-header-actions">
          {isSsoConnectionRequired() ? null : (
            <Button
              onClick={handleAdd}
              size="md"
              testId={LAUNCHPAD_ENDPOINTS_ADD_EXISTING}
              variant="tertiary-accent"
            >
              {copy.components.endpoints.dashboard.addExisting}
            </Button>
          )}
          <Button
            onClick={handleAddSso}
            size="md"
            testId={LAUNCHPAD_ENDPOINTS_ADD_SSO}
            variant="tertiary-accent"
          >
            {copy.components.endpoints.dashboard.addSso}
          </Button>
        </div>
      </div>

      <LaunchpadEndpointTable />
    </div>
  );
};
